export default "__VITE_ASSET__DvgCnSYm__"